import styled from "styled-components";

export const SelectStyle = styled.select`
width: ${props => props.width};
height: ${props => props.height};
margin-top: ${props => props.margintop};
border-radius: 5px;
border: 1px solid silver;
`